// §6.6 rarity pill — one shape (padding 5px 9px, radius 999, Hanken 700
// 9.5px tracked uppercase), four ranks (common / uncommon / rare /
// endemic), two surfaces (dark / on-light). Colors come exclusively
// from the rarity pill tokens in `tailwind.config.ts` — never from ad
// hoc bg-lime, text-magenta etc. anywhere else in the app.

export type RarityRank = "common" | "uncommon" | "rare" | "endemic";

const DARK: Record<RarityRank, string> = {
  common: "bg-pill-common-bg text-pill-common-fg",
  uncommon: "bg-pill-uncommon-bg text-pill-uncommon-fg",
  rare: "bg-pill-rare-bg text-pill-rare-fg",
  endemic: "bg-pill-endemic-bg text-pill-endemic-fg",
};
const LIGHT: Record<RarityRank, string> = {
  common: "bg-pill-common-bg-lt text-pill-common-fg-lt",
  uncommon: "bg-pill-uncommon-bg-lt text-pill-uncommon-fg-lt",
  rare: "bg-pill-rare-bg-lt text-pill-rare-fg-lt",
  endemic: "bg-pill-endemic-bg-lt text-pill-endemic-fg-lt",
};

const LABEL: Record<RarityRank, string> = {
  common: "Common",
  uncommon: "Uncommon",
  rare: "Rare",
  endemic: "Endemic",
};

export interface RarityPillProps {
  rank: RarityRank;
  /** Light context when true (on --paper / --sand). */
  onLight?: boolean;
  /** Override the visible label; keeps the tint. */
  label?: string;
  className?: string;
}

export function RarityPill({
  rank,
  onLight = false,
  label,
  className = "",
}: RarityPillProps) {
  const tint = onLight ? LIGHT[rank] : DARK[rank];
  return (
    <span
      className={`inline-flex items-center rounded-full px-[9px] py-[5px] text-[9.5px] font-bold uppercase leading-none tracking-[0.12em] ${tint} ${className}`}
    >
      {label ?? LABEL[rank]}
    </span>
  );
}
